/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import sortBy from 'lodash/sortBy';
import { Heading, ContentContainerBodyShift, FlexRow, FlexCol } from 'sarsaparilla';

import OpenCard from './OpenCard';
import { Lottery } from '../types/lottery';

interface OpenLotteriesProps {
    lotteries?: Lottery[];
}

export default function OpenLotteries({ lotteries }: OpenLotteriesProps) {
    const lotteriesSorted = sortBy(lotteries, 'open_at');
    const count = lotteriesSorted.length;

    return (
        <ContentContainerBodyShift id="open-lotteries" className="mt-6 mb-6">
            <FlexRow hasGutters={false}>
                <FlexCol>
                    <Heading
                        headingLevel={2}
                        hasUnderline="left"
                        appearance="h3"
                        className="lottery-section-header"
                    >
                        Open Lotteries
                    </Heading>
                </FlexCol>
            </FlexRow>

            <section>
                {count === 0 && (
                    <FlexRow className="lottery-no-results-wrap">
                        <FlexCol mdOffset={2} md={8}>
                            <p>
                                We appreciate your eagerness and enthusiasm for finding
                                your next adventure! However, there are currently{' '}
                                <strong>no open lotteries</strong>. You can check below to
                                see if anything is &quot;Coming Soon&quot; or review the
                                &quot;Closed&quot; lottery section to look up when
                                different lotteries historically open.
                            </p>
                        </FlexCol>
                    </FlexRow>
                )}
                <FlexRow hasGutters={false}>
                    {lotteriesSorted.map((lottery) => (
                        <OpenCard key={lottery.id} lottery={lottery} />
                    ))}
                </FlexRow>
            </section>
        </ContentContainerBodyShift>
    );
}
